import React from "react";

export function FilterCheckbox({
  filterState,
  setFilterState,
  filterName,
  stateKey,
}: {
  filterState: any;
  setFilterState: (state: any) => void;
  filterName: string;
  stateKey: string;
}) {
  return (
    <div className="filterCheckbox">
      <div className="filterCheckboxInput">
        <input
          type="checkbox"
          checked={stateKey in filterState ? filterState[stateKey] : false}
          onChange={() =>
            setFilterState((prevState: any) => ({
              ...prevState,
              [stateKey]: !(stateKey in prevState
                ? prevState[stateKey]
                : false),
            }))
          }></input>
      </div>
      <div className="filterCheckboxLabel">{filterName}</div>
    </div>
  );
}
